import { Contact } from '@commerce-myshop-webcomponents/sdk/services/models/Contact';
import { Social } from '@commerce-myshop-webcomponents/sdk/services/models/Social';

export interface ShopHeaderProps {
  shopName: string;
  shopDescription: string;
  shopCode?: string;
  profileUrl: string;
  bannerUrl: string;
  socialInfo?: Array<Social>;
  status: string;
  redirectionUrl: string;
  isCreator?: boolean;
  isReceiver?: boolean;
  contactInfo?: Array<Contact>;
}

export enum ContactTypeEnum {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
}
